<template>
  <div ref="content" class="content">
    <wiki-editor-renderer :editorData="editorData"></wiki-editor-renderer>
  </div>
</template>

<script>
// plugins
// import eventBus from "@/plugins/eventBus";
import WikiEditorRenderer from "@/views/editor/wiki-editor/wiki-editor-renderer.jsx";

export default {
  name: "DetailThridContent",
  components: {
    WikiEditorRenderer
  },
  props: {
    contentData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      detail: {}
    };
  },
  computed: {
    editorData() {
      const content_json = this.contentData.content_json;
      return content_json ? JSON.parse(content_json) : [];
    }
  },
  created() {},
  mounted() {
    // 预览图片
    const imgs = this.$refs.content.querySelectorAll(".preview-image");
    Array.prototype.forEach.call(imgs, (img, index) => {
      img.addEventListener("click", () => {
        this.handleImgPreview(imgs, index);
      });
    });
  },
  methods: {
    // 图片预览
    handleImgPreview(imgs, index) {
      const urls = Array.prototype.map.call(imgs, img => img.src);
      this.$imgViewShow(urls, index);
    }
  }
};
</script>

<style lang="less"></style>
